import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import logoVideo from '../assets/images/Logos (280 x 280 px).mp4';

const Hero = () => {
  return (
    <HeroSection>
      <div className="container">
        <HeroContent>
          <motion.div
            className="hero-text-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <HeroTitle>
              Learn how to 10x your productivity with AI
            </HeroTitle>
            <HeroText>
              Personalised AI coaching for small business owners and corporate professionals who want practical, actionable strategies. 
            </HeroText>
            <HeroSubtext>
              No tech background required.
            </HeroSubtext>
            <CallToAction href="#booking">
              Book Now
            </CallToAction>
            <Quote>
              "AI won't replace you. Someone Using AI Will."
            </Quote>
          </motion.div>
          <motion.div
            className="hero-video-content"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <VideoContainer>
              <video autoPlay loop muted playsInline>
                <source src={logoVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </VideoContainer>
          </motion.div>
        </HeroContent>
      </div>
    </HeroSection>
  );
};

const HeroSection = styled.section`
  background: linear-gradient(90deg, #f8f9fa 0%, #f6f7f8 100%);
  padding: 6rem 0;
  text-align: center;
`;

const HeroContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 2rem;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .hero-text-content {
    text-align: left;
    
    @media (max-width: 992px) {
      text-align: center;
    }
  }
`;

const VideoContainer = styled.div`
  max-width: 500px;
  margin-left: auto;
  
  video {
    width: 100%;
    height: auto;
    border-radius: 0;
    box-shadow: none;
  }
  
  @media (max-width: 992px) {
    margin: 0 auto;
  }
`;

const HeroTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  max-width: 800px;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const HeroText = styled.p`
  font-size: 1.25rem;
  max-width: 700px;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const HeroSubtext = styled.p`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const CallToAction = styled.a`
  display: inline-block;
  background-color: var(--primary-color);
  color: var(--white);
  padding: 1rem 2rem;
  border-radius: 4px;
  font-weight: 600;
  font-size: 1.1rem;
  transition: var(--transition);
  
  &:hover {
    background-color: #003b8a;
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
`;

const Quote = styled.p`
  font-style: italic;
  font-size: 1.4rem;
  color: var(--dark-blue);
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

export default Hero;
